<template>
  <div class="v-tooltip">
    <p
      class="contents"
      @mouseover="isOpen = true"
      @mouseleave="isOpen = false"
    >
      <slot name="contents" />
    </p>
    <div
      class="message"
      v-if="isOpen"
    >
      <slot name="tooltip" />
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    isOpen: false
  })
}
</script>

<style lang="scss" scoped>
@import "~@abeja-inc/abeja-ui-library/scss/_variables.scss";
.v-tooltip {
  display: contents;
  .message {
    position: absolute;
    top: 40px;
    right: 40px;
    width: 15vw;
    max-width: 400px;
    z-index: 300;
    padding: 12px;
    font-weight: $font-weight-semibold;
    background-color: $grey-100;
    border: solid 1px $grey-400;
    border-radius: 12px;
    // box-shadow: 4px 4px rgba($grey-600, 0.5);
    box-shadow: $box-shadow;
  }
}
</style>
